import { lobby, model, net } from './state.js';

// Keep in sync with COLORS in shared/game-engine.js.
const DEFAULT_PLAYER_COLORS = [
  '#ffe135', '#ff9224', '#ff4053', '#ff6ec7', '#a95cff',
  '#4769ff', '#22dfdf', '#3ee06b', '#f5f6ff'
];

function playerColorById(playerId) {
  const players = Array.isArray(model.state?.players) ? model.state.players : [];
  const statePlayer = players.find((player) => Number(player?.id) === Number(playerId));
  if (typeof statePlayer?.color === 'string' && statePlayer.color) {
    return statePlayer.color;
  }
  const colors = Array.isArray(model.config?.colors) && model.config.colors.length > 0
    ? model.config.colors
    : DEFAULT_PLAYER_COLORS;
  const normalized = Math.abs(Number(playerId) || 0);
  return colors[normalized % colors.length];
}

function playerLabelById(playerId, { capitalizeYou = false } = {}) {
  const id = Number(playerId);
  if (!Number.isFinite(id)) return 'Player';

  const isLocalPlayer = Number.isFinite(net.localPlayerId) && Number(net.localPlayerId) === id;

  const rosterPlayer = Array.isArray(lobby.players)
    ? lobby.players.find((player) => Number(player?.playerId) === id)
    : null;
  const rosterLabel = typeof rosterPlayer?.name === 'string' ? rosterPlayer.name.trim() : '';

  const statePlayers = Array.isArray(model.state?.players) ? model.state.players : [];
  const statePlayer = statePlayers.find((player) => Number(player?.id) === id);
  const stateLabel = typeof statePlayer?.label === 'string' ? statePlayer.label.trim() : '';
  const localName = typeof net.playerName === 'string' ? net.playerName.trim() : '';

  if (isLocalPlayer) {
    if (rosterLabel) return rosterLabel;
    if (localName) return localName;
    if (stateLabel) return stateLabel;
    return capitalizeYou ? 'You' : 'YOU';
  }

  if (rosterLabel) return rosterLabel;
  if (stateLabel) return stateLabel;

  return `Player ${id + 1}`;
}

function sameHostName(a, b) {
  return String(a || '').trim().toLowerCase() === String(b || '').trim().toLowerCase();
}

export {
  playerColorById,
  playerLabelById,
  sameHostName
};
